import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';
import messages from "../messages.js";


export default {

    getForms(input) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/applications/0/appforms?" + input, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching application forms"
                    });
                }
            });
    },
    getApplications() {
        return axios.get(constants.BASE_URL + "/applications/0/appforms/all-applications", {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    getApplicationInfo(appId) {
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/appforms/form-application", {
            withCredentials: true
        }).then(response => {

            return response.data.data;
        });
    },
    saveForm(appDto, appId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/applications/" + appId + "/appforms", appDto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    saveUpdatedForm(appFormDto, appId, formId) {
        axios.defaults.withCredentials = true;


        return axios.put(constants.BASE_URL + "/applications/" + appId + "/appforms/" + formId, appFormDto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    getFormDetails(appId, formId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/appforms/" + formId)
            .then(response => {
                return response.data;
            })
            .catch(error => {

            });
    },
    getFormDesignerDetails(url) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + url)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    disableApplicationForm(appId, formId, deletedReason) {
        axios.defaults.withCredentials = true;
        return axios.delete(constants.BASE_URL + "/applications/" + appId + "/appforms/" + formId + "?deletedReason=" + deletedReason).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    enableApplicationForm(appId, formId) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/applications/" + appId + "/appforms/" + formId + "/restore").then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    copyForm(appId, formId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/appforms/copy/" + formId).then(response => {
            return response;
        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    }, getMultipleCopyInfo(formIds) {
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + "/applications/0/appforms/copy-multiple", null, { params: { formIds: formIds } }, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching form copy details"
                    });
                }
            });
    }, saveMultipleCopy(appForms) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/applications/0/appforms/save-multiple", appForms)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response.data;
            })
    },
    saveFormDesign(url, data) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + url, data).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": "Could not process your request"
            });
        });
    },
    getFormsForImport() {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/0/appforms/getFormsForImport")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    getFormForImport(formId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/0/appforms/" + formId + "/getFormForImport")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    getAllFormTemplates() {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/templates/all/FORM")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    getTemplateFormForImport(selectedTemplate) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/templates/form-template/" + selectedTemplate
        + "/form-data")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    getFormHistoryData(url) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + url)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    getAutoSaveData() {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/users/manage/auto-saved-data")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    saveAutoSaveConfigurations(autoSaveFormDesigner, interval) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/users/auto-save-formdesigner-configurations", null, { params: { autoSaveFormDesigner, interval }}).then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": "Auto Save Error"
            });
        });
    },
}
